export const REVIEW_STATUSES = ['DRAFT', 'SHARED', 'ACKNOWLEDGED'] as const;
export type ReviewStatus = (typeof REVIEW_STATUSES)[number];

export const WARNING_LEVELS = ['VERBAL', 'WRITTEN', 'FINAL'] as const;
export type WarningLevel = (typeof WARNING_LEVELS)[number];

export const REVIEW_SCORE_MIN = 1;
export const REVIEW_SCORE_MAX = 5;

export const REVIEW_CYCLE_MONTHS_DEFAULT = 6;

/** Days before a review falls due that its reviewer is reminded. */
export const REVIEW_REMINDER_DAYS = 7;
